var _path, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderGotToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21195 5.57115L2.5907 8.59647C1.1599 11.5074 3.71269 15.6921 8.29253 17.9432C12.8724 20.1943 17.745 19.6594 19.1758 16.7485L20.4976 14.1427",
    stroke: "#459188",
    strokeWidth: 1.97143,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5239,
    cy: 9.34631,
    rx: 5.873,
    ry: 9.24012,
    transform: "rotate(-63.8246 12.5239 9.34631)",
    stroke: "#459188",
    strokeWidth: 1.97143
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7432 8.56934L14.3213 10.3037L11.8896 9.86133L11.502 8.12012L13.7432 8.56934Z",
    stroke: "#459188",
    strokeWidth: 1.97143,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderGotToken);
export default __webpack_public_path__ + "static/media/OrderGotToken.299a28b6ade3c0f124fae15dfdc56db6.svg";
export { ForwardRef as ReactComponent };